// import MainNavbar from '../../layout/MainNavbar.vue';
const MainNavbar  = () => import('@/layout/MainNavbar.vue')
export default [
{
        path: '/group/my',
        name: 'my',
        components: { default:resolve => require (['@/module/group/pages/IndexFollows.vue'],resolve)},
        meta:{
            title:"海外群吧 - 您的动态"
        }
    },
    {
        path: '/group/new',
        name: 'newGroup',
        components: { default:resolve => require (['@/module/group/pages/IndexNewest.vue'],resolve)},
        meta:{
            title:"海外群吧-最新群吧"
        }
    },
    {
        path: '/group/p/:groupid',
        name: 'articleGroup',
        components: { default:resolve => require (['@/module/group/pages/article/ArticlePage.vue'],resolve)},

    },
    {  // 群吧首页 群吧信息 postID=6690405
        path: '/group/index/:id',
        name: 'myGroup',
        components: { default:resolve => require (['@/module/group/user/group/Index.vue'],resolve)},
        meta:{
            title:"海外群吧"
        }
    },
    {
        path: '/group/list/:id',
        name: 'list',
        components: { default:resolve => require (['@/module/group/user/IndexCategory.vue'],resolve)},
        meta:{
            title:"海外群吧-推荐"
        }
    },
    {
        path: '/group/discover',
        name: 'discover',
        components: { default:resolve => require (['@/module/group/pages/Index.vue'],resolve)},

        // components: { default:resolve => require (['@/module/group/user/IndexDiscover.vue'],resolve)},
        meta:{
            title:"海外群吧 - 推广置顶"
        }
    },
    {
        path: '/group',
        name: 'index',
        // components: { default:resolve => require (['@/module/group/pages/Index.vue'],resolve)},
        components: { default:resolve => require (['@/module/group/user/IndexDiscover.vue'],resolve)},

        meta:{
            title:"海外群吧 - 热门群吧"
        }
    },


]
